import { render } from "./AddressModal.vue?vue&type=template&id=93216282&scoped=true"
import script from "./AddressModal.vue?vue&type=script&lang=js"
export * from "./AddressModal.vue?vue&type=script&lang=js"

import "./AddressModal.vue?vue&type=style&index=0&id=93216282&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93216282"]])

export default __exports__